module.exports = __webpack_public_path__ + "assets/07be517111ab78da21d0fd1030866258.png";